<template>
  <div :id="id" :style="`width: 100%; height: 100%; min-height: 320px; max-height: 320px; min-width: 200px;`"></div>
</template>

<script>
import loadChart from './loadChart';

export default {
  name: 'GraficoRosca',
  props: {
    id: {
      type: String,
      required: true,
    },
    categoryField: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    valueFields: {
      type: Object,
      required: true,
    },
    dados: {
      type: Array,
      required: true,
    },
    innerRadius: {
      type: [String, Number],
      default: '50%',
    },
    showExport: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    dados() {
      if (this.isReady) {
        this.montarGrafico();
      }
    },
  },
  data() {
    return {
      isReady: false,
      chartInstance: null,
    };
  },
  methods: {
    calcularHideLabelsPercent() {
      const valueField = this.valueFields.valueField || 'valor';
      const totalValores = (this.dados || []).reduce((acc, item) => acc + (item[valueField] || 0), 0);
      const sextoValor = (this.dados && this.dados.length > 5) ? (this.dados[5][valueField] || 0) : 0;
      if (this.dados && this.dados.length > 5 && totalValores > 0) {
        return ((sextoValor / totalValores) * 100) + 0.0001;
      }

      return 0;
    },
    montarGrafico() {
      if (typeof AmCharts === 'undefined' || !this.isReady) return;
      if (!this.dados || this.dados.length === 0) return;

      if (this.chartInstance) {
        if (this.chartInstance.clear) {
          this.chartInstance.clear();
        }
        this.chartInstance = null;
      }

      const pie = {
        type: 'pie',
        titles: [{
          text: this.title,
          size: 24,
          color: '#1B5499',
        }],
        theme: 'none',
        dataProvider: this.dados,
        ...this.valueFields,
        hideLabelsPercent: this.calcularHideLabelsPercent(),
        innerRadius: this.innerRadius,
        radius: '30%',
        legend: {
          position: 'right',
          markerType: 'circle',
          labelText: '[[title]]',
          valueText: '',
          switchable: false,
        },
        export: {
          enabled: this.showExport && !!(this.dados && this.dados.length > 0),
          fileName: this.title,
          pageOrigin: false,
          menu: [{
            class: 'export-main',
            menu: ['JPG', 'PNG', 'PDF'],
          }],
        },
        colors: ['#4285f4', '#ff9901'],
      };

      this.chartInstance = AmCharts.makeChart(this.id, pie);
    },
  },
  mounted() {
    window.addEventListener('AmChartCarregado', () => {
      this.isReady = true;
    });
  },
  beforeMount() {
    loadChart().then(() => {
      this.isReady = true;
      window.dispatchEvent(new Event('AmChartCarregado'));
      this.montarGrafico();
    });
  },
  beforeDestroy() {
    if (this.chartInstance) {
      if (this.chartInstance.clear) {
        this.chartInstance.clear();
      }
      this.chartInstance = null;
    }
  },
};
</script>

<style scoped>
  ::v-deep .amcharts-legend-div {
    max-height: 290px !important;
    overflow-y: auto !important;
  }
</style>
